import { Autocomplete, AutocompleteOption, createFilterOptions, VariantProp } from '@healthinal/ui';
import { useEffect, useState } from 'react';
import { useGetContactPatientContactPlaces } from '../../../../../api/generated/contact-tracing-place-controller/contact-tracing-place-controller.ts';
import { ContactTracingPlaceDto } from '../../../../../api/generated/model';
import { CreateContactPatientContactPlaceDialog } from './CreateContactPatientContactPlaceDialog.tsx';

interface Props {
  onChange: (contactPlace: ContactTracingPlaceDto | null) => void;
  value: ContactTracingPlaceDto | null;
  variant?: VariantProp;
}

export function SelectContactPatientContactPlace({ onChange, value, variant }: Props) {
  const defaultFilterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: ContactTracingPlaceDto) => option.name,
  });

  const { data: contactPatientContactPlaces, isPending } = useGetContactPatientContactPlaces();

  const [isCreateNewContactPlaceDialogOpen, setIsCreateNewContactPlaceDialogOpen] = useState(false);
  const [newContactPlace, setNewContactPlace] = useState<ContactTracingPlaceDto | null>(null);

  useEffect(() => {
    if (
      contactPatientContactPlaces &&
      newContactPlace &&
      contactPatientContactPlaces.some((place) => place.name === newContactPlace.name)
    ) {
      setNewContactPlace(null);
    }
  }, [contactPatientContactPlaces]);

  return (
    <>
      <Autocomplete
        value={value}
        onChange={(_, value) => onChange(value)}
        loading={isPending}
        options={
          newContactPlace
            ? [...(contactPatientContactPlaces ?? []), newContactPlace]
            : (contactPatientContactPlaces ?? [])
        }
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        filterOptions={(options, state) => {
          const filtered = defaultFilterOptions(options, state);
          return [...filtered, { name: 'Ort erstellen' } as ContactTracingPlaceDto];
        }}
        renderOption={(props, option) =>
          option.name !== 'Ort erstellen' ? (
            <AutocompleteOption {...props} key={option.name}>
              {option.name}
            </AutocompleteOption>
          ) : (
            <AutocompleteOption key={option.name} onClick={() => setIsCreateNewContactPlaceDialogOpen(true)}>
              Neuer Kontakt Ort erstellen
            </AutocompleteOption>
          )
        }
        variant={variant}
      />
      <CreateContactPatientContactPlaceDialog
        open={isCreateNewContactPlaceDialogOpen}
        onClose={(contactPlace) => {
          setIsCreateNewContactPlaceDialogOpen(false);
          if (contactPlace) {
            setNewContactPlace(contactPlace);
            onChange(contactPlace);
          }
        }}
        currentContactPlaces={contactPatientContactPlaces ?? []}
      />
    </>
  );
}
